<template>
  <div class="page-shell page-shell--spacious">
    <h1 class="font-helvetica-700 font-bold uppercase text-[40px]">
      Категории товаров
    </h1>
    <div class="flex">
      <button
        type="button"
        class="inline-flex min-h-10 items-center gap-2 rounded-[8px] border border-gray-border bg-white px-3 py-2 text-left text-[15px] leading-[20px] font-helvetica-700 text-gray-dark transition-colors hover:border-orange hover:text-orange disabled:cursor-not-allowed disabled:opacity-60"
        :disabled="priceListLoading"
        @click="downloadPriceList"
      >
        <img
          src="/filetype-xlsx.svg"
          alt=""
          aria-hidden="true"
          class="h-6 w-6 shrink-0"
        />
        <span>
          {{
            priceListLoading
              ? "Загружаем прайс-лист..."
              : "Скачать актуальный прайс-лист"
          }}
        </span>
      </button>
    </div>
    <p
      v-if="priceListError"
      class="max-w-[520px] text-[13px] leading-[18px] font-helvetica-400 text-orange"
    >
      {{ priceListError }}
    </p>
    <div class="flex flex-wrap gap-4">
      <GoodsType
        href="/search/tires/"
        src="/goods/tires.webp"
        image-class="object-contain object-center"
      >
        Шины
      </GoodsType>
      <!-- <GoodsType href="/search/wheel" src="/goods/wheel_assembly.webp">Колесо в сборе</GoodsType> -->
      <!-- <GoodsType href="/search/axles" src="/goods/axles_and_hubs.webp">Оси и ступицы</GoodsType> -->
      <!-- <GoodsType href="/search/hydraulics" src="/goods/hydraulics.webp">Гидравлика</GoodsType> -->
      <GoodsType
        href="/search/discs"
        src="/goods/discs.webp"
        image-class="object-contain object-center"
      >
        Диски колесные
      </GoodsType>
      <!-- <GoodsType href="/search/staf" src="/goods/staf.webp">Запчасти</GoodsType> -->
      <GoodsType href="/search/cam" src="/goods/cam.webp"
        >Камеры, ленты, кольца</GoodsType
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { useNuxtApp } from "#imports";
import GoodsType from "~/components/goods/GoodsType.vue";

usePageTitle("Категории товаров");

const PRICE_LIST_FILE_NAME = "actual-price-list.xls";

const priceListLoading = ref(false);
const priceListError = ref("");

const nuxtApp = useNuxtApp();
const $downloadOneCApi = nuxtApp.$downloadOneCApi as (
  action: string,
  payload?: Record<string, any>,
) => Promise<unknown>;

const ensurePriceListExtension = (fileName: string, extension: string) => {
  const normalizedExtension = extension.replace(/^\./, "").trim() || "xls";
  const cleanName = fileName
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, "_")
    .trim()
    .replace(/(\.(?:xlsx?|xls))+$/i, "");

  return `${cleanName || "actual-price-list"}.${normalizedExtension}`;
};

const getFileNameFromUrl = (url: string) => {
  try {
    const { pathname } = new URL(url);
    const name = decodeURIComponent(
      pathname.split("/").filter(Boolean).pop() || "",
    );
    return name || PRICE_LIST_FILE_NAME;
  } catch {
    return PRICE_LIST_FILE_NAME;
  }
};

const clickDownloadLink = (url: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const downloadBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  clickDownloadLink(url, fileName);

  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
};

const downloadPriceListUrl = async (url: string, fileName: string) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to load price list file");
    downloadBlob(await response.blob(), fileName);
  } catch {
    clickDownloadLink(url, fileName);
  }
};

const downloadPriceList = async () => {
  if (process.server || priceListLoading.value) return;

  priceListLoading.value = true;
  priceListError.value = "";

  try {
    const response = await $downloadOneCApi("getPriceLists", {});
    const file = (
      response as { Файл?: { СсылкаS3?: string; Расширение?: string } }
    )?.Файл;
    const url = String(file?.СсылкаS3 || "").trim();

    if (!url) {
      throw new Error("Прайс-лист не найден.");
    }

    const fileName = ensurePriceListExtension(
      getFileNameFromUrl(url),
      String(file?.Расширение || "xls"),
    );
    await downloadPriceListUrl(url, fileName);
  } catch (error) {
    console.error("Не удалось скачать прайс-лист", error);
    priceListError.value = "Не удалось скачать прайс-лист. Попробуйте позже.";
  } finally {
    priceListLoading.value = false;
  }
};
</script>
